import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-76">
      {/* Background Image with Warm Dark Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-77">
        <img src="https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?w=1600&auto=format&fit=crop&q=80" alt="Las Vegas Nevada skyline" className="w-full h-full object-cover" data-id="element-78" />
        {/* Warm dark overlay matching their brand */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#2d2d2d]/95 via-[#2d2d2d]/85 to-[#2d2d2d]/70" data-id="element-79" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-80">
        <div className="max-w-3xl" data-id="element-81">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-gray-300 text-lg md:text-xl mb-4 font-medium" data-id="element-82">
            Nevada's most trusted name in electrical services.
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight uppercase" data-id="element-83">
            BUILD YOUR NEXT PROJECT WITH{' '}
            <span className="text-[#FFD700]" data-id="element-84">HONESTY</span> AND QUALITY.
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col sm:flex-row items-start gap-4 mb-12" data-id="element-85">
            <button className="flex items-center justify-center gap-2 bg-[#FFD700] hover:bg-[#e6c200] text-[#1f1f1f] px-8 py-4 rounded-full font-bold text-lg transition-colors w-full sm:w-auto" data-id="element-86">
              Get an Instant Quote
              <ArrowRight className="w-5 h-5" data-id="element-87" />
            </button>
            <a href="tel:+17025550123" className="flex items-center justify-center gap-2 bg-transparent border border-white/30 hover:border-white text-white px-8 py-4 rounded-full font-medium text-lg transition-colors w-full sm:w-auto" data-id="element-88">
              Call (702) 555-0123
            </a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-gray-400 text-sm mb-12" data-id="element-89">
            *Fast response times and upfront pricing guaranteed.
          </motion.p>

          {/* Social Proof matching their style */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-90">
            <div className="flex -space-x-3" data-id="element-91">
              <img className="w-12 h-12 rounded-full border-2 border-[#2d2d2d] object-cover" src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80" alt="Customer" data-id="element-92" />
              <img className="w-12 h-12 rounded-full border-2 border-[#2d2d2d] object-cover" src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=100&q=80" alt="Customer" data-id="element-93" />
              <img className="w-12 h-12 rounded-full border-2 border-[#2d2d2d] object-cover" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80" alt="Customer" data-id="element-94" />
              <img className="w-12 h-12 rounded-full border-2 border-[#2d2d2d] object-cover" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80" alt="Customer" data-id="element-95" />
              <div className="w-12 h-12 rounded-full border-2 border-[#2d2d2d] bg-[#3a3a3a] flex items-center justify-center text-xs font-bold text-white" data-id="element-96">
                500+
              </div>
            </div>

            <div data-id="element-97">
              <div className="flex items-center gap-1 text-[#FFD700] mb-1" data-id="element-98">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-99" />)}
              </div>
              <p className="text-white font-medium" data-id="element-100">
                Trusted by 500+ homeowners & businesses
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}